import "./MetroXBrandBarEmployee.scss";

import * as React from "react";
import { History } from "history";
import { SessionStore } from "../../../uidispatcherapi/SessionStore";
import BrandbarAccountInformation from "./accountFlyout/BrandbarAccountInformation";
import { getComponentByName } from "../../LazyWrapper";
const MetroLogo = getComponentByName("sd_articlesearch_ui/MetroLogo");

type Props = {
    history?: History;
};
export const MetroXBrandBarEmployee = (props: Props) => {
    const handleLogoClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (props.history) {
            event.preventDefault();
            props.history.push("/");
        }
        return null;
    };

    return (
        <div className="metrox-brandbar">
            <div className="metrox-employee-brandbar">
                <div onClick={(event) => handleLogoClick(event)} className="brandbar-metro-logo navbar-brand">
                    <MetroLogo country={SessionStore.getCountry()} />
                </div>
                <BrandbarAccountInformation history={props.history} />
            </div>
        </div>
    );
};
